import { HttpError } from "../HttpClient";
import { getErrorMessage } from "./errorHandler";

/**
 * Turns a failed request into the Error a service rethrows.
 *
 * An HTTP failure is translated through its `errorCode`. Without a known code
 * it keeps the status message `HttpClient` already wrote (session expired, no
 * permission, server down), which says more than the operation's default.
 * Anything else — a network failure's English "Failed to fetch" — falls back
 * to the default.
 *
 * Wrap only the request in the `try`: a Portuguese Error the service throws
 * itself is not an HttpError, so it would be replaced by the default here.
 */
export const toServiceError = (error: unknown, defaultMessage: string): Error =>
  new Error(
    getErrorMessage(
      error,
      error instanceof HttpError ? error.message : defaultMessage,
    ),
  );
